module.exports = __webpack_public_path__ + "static/media/bg-presse.0dc8ee66.jpg";